import React from 'react';
import { TblSort } from './table.types';
import { cssSortByIcon } from './utils/cssSortByIcon';

type TblTitleSortIconParams = {
    col: string;
    sort?: TblSort;
};

export const TableTitleSortIcon = ({ col, sort }: TblTitleSortIconParams): JSX.Element => {
    const sortIcon = !!sort && sort.col == col ? cssSortByIcon(sort.dir) : '';
    return <span className={sortIcon} />;
};
